export default {
    nav: {
        home: "Accueil",
        solutions: "Solutions",
        programmes: "Programmes & Capacity Building",
        expertises: "Expertises",
        sourcing: "Sourcing",
        about: "À propos",
        analyses: "Analyses",
        contact: "Contact",
        cta: "Réserver un échange de 30 min",
    },
    hero: {
        eyebrow: "Cabinet de développement international — France · Tunisie",
        line1: "Développez votre activité",
        line2a: "à ",
        line2b: "l'international",
        line2c: ",",
        line3: "de la stratégie à l'exécution",
        intro: "WEYB est un cabinet de conseil et d'accompagnement export basé en France et en Tunisie. Nous aidons les PME, dirigeants et équipes export à structurer et accélérer leur développement international, de la stratégie à l'exécution terrain.",
        ctaPrimary: "Réserver un échange de 30 min avec Saber",
        ctaSecondary: "Découvrir nos solutions",
        zoneNote: "France — siège · Tunisie — filiale · réseau international de partenaires",
    },
    marquee: ["Stratégie export", "Études de marché", "Prospection B2B", "Salons internationaux", "Missions B2B", "Coaching export", "Implantation internationale", "Export360"],
    solutions: {
        eyebrowIndex: "01",
        eyebrow: "Quatre domaines d'intervention",
        title: "De la première étude de marché à votre implantation locale.",
        cards: [
            {
                num: "01",
                title: "Développement international",
                value: "De la stratégie à l'exécution terrain, un accompagnement complet de votre croissance export.",
                items: ["Diagnostic & stratégie export", "Études & priorisation marchés", "Prospection B2B & closing", "Salons & missions B2B"],
                cta: "Découvrir la solution",
            },
            {
                num: "02",
                title: "Programmes d'appui & Capacity Building",
                value: "Conception, formation, mise en œuvre et évaluation de programmes d'internationalisation, aux côtés des structures d'appui et partenaires du développement.",
                items: ["Conception de programmes", "Training of Trainers (ToT)", "Formation & coaching des entreprises", "Monitoring & Evaluation"],
                cta: "Découvrir l'approche",
            },
            {
                num: "03",
                title: "Export360.fr",
                value: "La plateforme qui structure et pilote votre développement export, assistée par IA.",
                items: ["Diagnostics & priorisation", "Études assistées par IA", "E-learning, quiz & templates", "Marketplace d'études & coachs"],
                cta: "Découvrir Export360",
            },
            {
                num: "04",
                title: "Implantation & RH international",
                value: "Votre présence locale, sans friction : structure, équipes et support opérationnel.",
                items: ["Création de structure", "Recrutement & portage salarial", "Support administratif & comptabilité", "Mise en place d'équipes"],
                cta: "Découvrir la solution",
            },
        ],
    },
    institutions: {
        eyebrowIndex: "02",
        eyebrow: "Structures d'appui & institutions",
        title: "Vous accompagnez des entreprises à l'international ?",
        text: "WEYB accompagne les structures d'appui, institutions et partenaires du développement dans la conception et la mise en œuvre de programmes dédiés à l'internationalisation des entreprises.",
        stats: [
            { value: "15+", label: "structures d'appui & BSO" },
            { value: "300+", label: "PME accompagnées" },
            { value: "15+", label: "pays d'intervention" },
        ],
        blocks: [
            { title: "Conception de programmes", desc: "Transformer vos objectifs en dispositif opérationnel : méthodologie, parcours, outils et KPI." },
            { title: "Training of Trainers", desc: "Former vos conseillers et formateurs à déployer l'accompagnement en autonomie." },
            { title: "Formation & coaching", desc: "Former et coacher les entreprises bénéficiaires, en individuel et en collectif." },
            { title: "Mise en œuvre", desc: "Coordonner le déploiement du programme et le suivi des entreprises bénéficiaires." },
            { title: "Monitoring & Evaluation", desc: "Indicateurs, reporting, évaluation et capitalisation des résultats." },
        ],
        cta: "Découvrir notre approche programmes",
    },
    method: {
        eyebrowIndex: "04",
        eyebrow: "Méthode",
        title: "Un parcours en six temps, du diagnostic au pilotage.",
        steps: [
            { num: "01", title: "Diagnostiquer", desc: "Diagnostic export complet : potentiel, capacités, maturité internationale." },
            { num: "02", title: "Prioriser", desc: "Hiérarchisation des marchés à plus fort potentiel pour votre offre." },
            { num: "03", title: "Préparer", desc: "Études, positionnement, argumentaire et outils commerciaux adaptés." },
            { num: "04", title: "Prospecter", desc: "Identification et qualification de partenaires, prospection B2B ciblée." },
            { num: "05", title: "Déployer", desc: "Salons internationaux, missions B2B, closing et implantation locale." },
            { num: "06", title: "Piloter", desc: "Suivi, indicateurs et pilotage continu de votre développement export." },
        ],
    },
    export360: {
        eyebrowIndex: "05",
        eyebrow: "Export360 — la plateforme",
        titleA: "Votre développement export,",
        titleB: " structuré et piloté",
        titleC: ".",
        desc: "Export360 est la plateforme développée par WEYB pour structurer, piloter et accélérer le développement à l'international des entreprises — du diagnostic initial aux opportunités business.",
        features: ["Diagnostics export", "Priorisation marchés", "Études assistées par IA", "Préparation salons & missions", "Templates & e-learning", "Quiz & leaderboard", "Chatbot IA", "Marketplace d'études", "Coachs & consultants", "Opportunités business"],
        cta: "Découvrir Export360.fr",
        visualAlt: "La plateforme Export360 : diagnostics, pilotage et études assistées par IA",
        visualNote: "Visuel provisoire — captures officielles à intégrer",
    },
    zones: {
        eyebrowIndex: "06",
        eyebrow: "Zones & secteurs",
        title: "Une présence européenne, africaine et MENA. Une expérience multisectorielle.",
        zonesTitle: "Où nous intervenons",
        zonesNote: "Base en France, filiale en Tunisie, et un réseau de partenaires et experts internationaux.",
        zones: ["Europe", "Afrique", "MENA"],
        zonesImgAlt: "Salon international — présence terrain de WEYB",
        sectorsTitle: "Secteurs d'expérience",
        sectors: ["Agroalimentaire", "Industrie", "Services B2B", "Solutions technologiques"],
        sectorsNote: "Domaines d'expérience prioritaires — notre accompagnement s'adapte à tout secteur exportable.",
    },
    experiences: {
        eyebrowIndex: "03",
        eyebrow: "Écosystème & références",
        title: "Expériences et collaborations institutionnelles.",
        note: "Programmes, missions et collaborations menées au sein de cet écosystème — bailleurs, organismes d'appui, chambres de commerce et accélérateurs.",
    },
    founder: {
        eyebrowIndex: "08",
        eyebrow: "Le fondateur",
        name: "Saber Bellaaj",
        role: "Fondateur & CEO de WEYB",
        bio: "Plus de vingt ans passés sur le terrain du commerce international : stratégie export, développement commercial, coaching et accompagnement opérationnel des entreprises en Europe, en Afrique et dans la zone MENA.",
        stats: [
            { value: "20+", label: "ans en commerce international" },
            { value: "3", label: "zones : Europe · Afrique · MENA" },
            { value: "4", label: "langues : FR · EN · AR · IT" },
            { value: "Coach", label: "certifié, accompagnement dirigeants & équipes" },
        ],
        cta: "Découvrir WEYB et son fondateur",
        portraitAlt: "Saber Bellaaj, Fondateur & CEO de WEYB",
    },
    analyses: {
        eyebrowIndex: "09",
        eyebrow: "Analyses & publications",
        title: "Regard terrain sur le commerce international.",
        ctaAll: "Voir toutes les analyses",
        emptyTitle: "Les premières analyses arrivent prochainement.",
        emptyText: "Études de marché, retours de missions et décryptages export — publiés par Saber Bellaaj.",
    },
    finalCta: {
        eyebrow: "Prochaine étape",
        title: "Parlons de votre projet international.",
        desc: "Trente minutes avec Saber Bellaaj pour faire le point sur vos ambitions, vos marchés cibles et les premières actions à lancer.",
        ctaPrimary: "Réserver un échange de 30 min avec Saber",
        ctaSecondary: "Nous écrire",
    },
    footer: {
        definition: "Cabinet d'accompagnement au développement international. De la stratégie à l'exécution, aux côtés des entreprises, en Europe, en Afrique et dans la zone MENA.",
        france: "France",
        tunisia: "Tunisie",
        col1Title: "Solutions",
        col1: ["Développement international", "Programmes & Capacity Building", "Export360", "Implantation & RH international"],
        col2Title: "Cabinet",
        col2: ["À propos de WEYB", "Saber Bellaaj", "Analyses & Ressources", "Contact"],
        ctaTitle: "Parlons-en",
        ctaText: "Un projet à l'international ? Un premier échange, sans engagement.",
        ctaButton: "Réserver un échange de 30 min",
        rights: "WEYB. Tous droits réservés.",
        legal1: "Mentions légales",
        legal2: "Politique de confidentialité",
        legal3: "Préférences cookies",
    },
    solutionsPage: {
        eyebrowIndex: "Solutions",
        eyebrow: "Quatre domaines d'intervention",
        title: "De la stratégie à l'exécution, quatre façons d'accélérer votre international.",
        intro: "WEYB accompagne les entreprises, dirigeants et équipes export depuis la décision stratégique jusqu'à l'exécution opérationnelle — avec la technologie Export360 et un ancrage terrain en Europe, Afrique et MENA.",
        ctaTitle: "Une hésitation sur le point de départ ?",
        ctaText: "Un échange de 30 minutes suffit souvent à clarifier la priorité.",
        ctaButton: "Réserver un échange de 30 min",
    },
    solutionDetail: {
        breadcrumbHome: "Accueil",
        breadcrumbSolutions: "Solutions",
        eyebrowLabel: "Solution",
        ctaBooking: "Réserver un échange de 30 min",
        ctaContact: "Nous écrire",
        constatEyebrow: "Le constat",
        constatTitle: "Pourquoi c'est difficile sans accompagnement.",
        pourQuiEyebrow: "Pour qui",
        pourQuiTitle: "Pensé pour les équipes qui veulent passer à l'action.",
        actionsEyebrow: "Ce que WEYB fait",
        actionsTitle: "{n} leviers d'action, un seul interlocuteur.",
        livrablesEyebrow: "Résultats attendus",
        livrablesTitle: "Des livrables concrets, pas des promesses.",
        faqEyebrow: "FAQ",
        faqTitle: "Questions fréquentes.",
        ctaTitle: "Parlons de votre projet international.",
        ctaText: "Trente minutes avec Saber Bellaaj pour cadrer vos priorités.",
        ctaButton: "Réserver un échange de 30 min",
        nextLabel: "Solution suivante",
    },
    expertisesPage: {
        eyebrowIndex: "Expertises",
        eyebrow: "Cinq domaines d'intervention",
        title: "Des expertises terrain, du diagnostic export aux missions B2B.",
        intro: "Chaque expertise de WEYB correspond à une étape concrète de votre développement international — et s'intègre dans un parcours complet, de la stratégie à l'exécution.",
        ctaTitle: "Quelle expertise mobiliser en premier ?",
        ctaText: "Un échange de 30 minutes permet de le déterminer ensemble.",
        ctaButton: "Réserver un échange de 30 min",
    },
    expertiseDetail: {
        breadcrumbHome: "Accueil",
        breadcrumbExpertises: "Expertises",
        eyebrowLabel: "Expertise",
        ctaBooking: "Réserver un échange de 30 min",
        ctaContact: "Nous écrire",
        pointsEyebrow: "Ce que couvre cette expertise",
        pointsTitle: "Un périmètre précis, une exécution soignée.",
        outcomesEyebrow: "Ce que vous y gagnez",
        outcomesTitle: "Des résultats tangibles.",
        solutionLink: "Cette expertise s'intègre au pôle {label}",
        ctaTitle: "Parlons de votre projet international.",
        ctaText: "Trente minutes avec Saber Bellaaj pour cadrer vos priorités.",
        ctaButton: "Réserver un échange de 30 min",
        nextLabel: "Expertise suivante",
    },
    apropos: {
        heroEyebrow: "Le cabinet",
        heroEyebrowIndex: "À propos",
        heroTitle: "WEYB, votre partenaire de croissance à l'international.",
        heroIntro: "WEYB est un cabinet d'accompagnement au développement international, basé en France avec une filiale en Tunisie. Nous accompagnons les entreprises, dirigeants et équipes export depuis la stratégie jusqu'à l'exécution opérationnelle, en Europe, en Afrique et dans la zone MENA.",
        historyEyebrow: "Notre histoire",
        historyTitle: "Une aventure de terrain, depuis 2011.",
        timeline: [
            { year: "2011", title: "L'origine en Tunisie", text: "L'activité débute avec BMCC en Tunisie : accompagnement des entreprises et premières missions de développement international." },
            { year: "2022", title: "Création de WEYB à Marseille", text: "Saber Bellaaj fonde WEYB à Marseille pour structurer l'accompagnement des entreprises, de la stratégie export à l'exécution opérationnelle." },
            { year: "Aujourd'hui", title: "Un cabinet France — Tunisie, ouvert sur le monde", text: "WEYB poursuit son développement depuis la France, avec une filiale en Tunisie et un réseau international de partenaires, experts et consultants." },
        ],
        founderEyebrow: "Le fondateur",
        founderRole: "Fondateur & CEO de WEYB",
        founderBio: "Plus de 20 ans d'expérience en commerce international : stratégie export, développement commercial, coaching et accompagnement opérationnel des entreprises en Europe, en Afrique et dans la zone MENA. Une expertise construite sur le terrain, au contact des entreprises et des institutions.",
        coachBadge: "Coach certifié",
        chainExpertises: "Expertises",
        portraitAlt: "Saber Bellaaj, Fondateur & CEO de WEYB",
        pillarsEyebrow: "Quatre piliers",
        pillarsTitle: "Une offre structurée, du conseil à l'opérationnel.",
        pillars: [
            { title: "Développement international", desc: "Diagnostic, stratégie, études, prospection B2B, salons et missions — le parcours export complet.", cta: "Découvrir" },
            { title: "Programmes d'appui & Capacity Building", desc: "Conception, formation, mise en œuvre et évaluation de programmes d'internationalisation, avec les structures d'appui et partenaires du développement.", cta: "Découvrir" },
            { title: "Export360", desc: "La plateforme qui structure et pilote le développement export, assistée par IA.", cta: "Découvrir" },
            { title: "Implantation & RH international", desc: "Création de structure, recrutement, portage salarial et support opérationnel.", cta: "Découvrir" },
        ],
        coachingEyebrow: "Coaching & formation",
        coachingTitle: "Transmettre, autant qu'accompagner.",
        coachingList: [
            "Coaching export des dirigeants",
            "Accompagnement des équipes commerciales",
            "Formations commerce international",
            "Développement commercial international",
            "Prospection et stratégie export",
            "Préparation salons et missions",
        ],
        qualiopiNote: "WEYB est actuellement en processus de certification Qualiopi. Lorsque nécessaire, WEYB peut intervenir avec un partenaire certifié.",
        agileEyebrow: "Un modèle agile",
        agileTitle: "Une équipe resserrée, un réseau international.",
        agileText: "WEYB fonctionne comme un cabinet agile : une équipe centrale resserrée, renforcée par un réseau de partenaires, d'experts et de consultants internationaux mobilisés selon les marchés et les besoins de chaque mission.",
        presenceTitle: "Présence internationale",
        presenceRows: [
            { place: "France", role: "Siège — Marseille" },
            { place: "Tunisie", role: "Filiale" },
            { place: "Europe · Afrique · MENA", role: "Réseau de partenaires" },
        ],
        refsEyebrow: "Écosystème & références",
        refsTitle: "Expériences et collaborations institutionnelles.",
        galleryEyebrow: "Terrain",
        galleryTitle: "Nos missions, en images.",
        galleryNote: "Formations, salons, missions B2B et visites d'entreprises — l'activité de WEYB, sur le terrain, en Europe, en Afrique et dans la zone MENA.",
        ctaTitle: "Envie de travailler avec WEYB ?",
        ctaPrimary: "Réserver un échange de 30 min avec Saber",
        ctaSecondary: "Découvrir nos solutions",
    },
    contact: {
        eyebrow: "Parlons de votre projet",
        eyebrowIndex: "Contact",
        title: "Un projet à l'international ? Écrivez-nous.",
        labelPrenom: "Prénom *",
        labelNom: "Nom *",
        labelEntreprise: "Entreprise",
        labelEmail: "Email professionnel *",
        labelPays: "Pays",
        labelBesoin: "Besoin",
        labelMessage: "Message *",
        phPrenom: "Votre prénom",
        phNom: "Votre nom",
        phEntreprise: "Nom de votre entreprise",
        phEmail: "prenom@entreprise.com",
        phPays: "France, Tunisie, Maroc…",
        phMessage: "Décrivez votre projet, vos marchés cibles, vos échéances…",
        besoins: ["Développement international", "Export360", "Implantation & RH international", "Coaching & Formation", "Autre besoin"],
        submit: "Envoyer le message",
        sending: "Envoi en cours…",
        successTitle: "Message bien reçu.",
        successText: "Merci pour votre message. Nous revenons vers vous rapidement. Pour aller plus vite, vous pouvez aussi réserver directement un échange de 30 minutes.",
        successCta: "Réserver un échange de 30 min",
        errorFallback: "Une erreur est survenue. Réessayez ou réservez directement un échange.",
        asideTitle: "Plus direct : 30 minutes avec Saber.",
        asideText: "Un premier échange sans engagement pour cadrer votre projet et identifier les prochaines étapes.",
        asideCta: "Réserver un créneau",
        franceNote: "Siège — coordonnées en cours de validation",
        tunisiaNote: "Filiale — coordonnées en cours de validation",
    },
    analysesPage: {
        eyebrow: "Ressources & publications",
        eyebrowIndex: "Analyses",
        title: "Analyses marchés, retours terrain et guides export.",
        intro: "Décryptages du commerce international par Saber Bellaaj et l'équipe WEYB : études, missions, salons et stratégie export.",
        emptyTitle: "Les premières analyses arrivent prochainement.",
        emptyText: "Aucun contenu n'est repris de l'ancien site sans validation — la migration éditoriale fera l'objet d'un inventaire dédié.",
    },
    stub: {
        eyebrow: "WEYB.fr — Construction en phases",
        titleSuffix: " — cette page arrive prochainement.",
        text: "Conformément au plan de travail validé, les pages sont construites et validées par étapes.",
        backHome: "Retour à l'accueil",
        cta: "Réserver un échange de 30 min",
    },
    notfound: {
        eyebrow: "Erreur 404",
        title: "Cette page n'existe pas ou plus.",
        text: "Le contenu recherché a peut-être été déplacé lors de la refonte du site. Voici les principaux accès :",
        home: "Retour à l'accueil",
        solutions: "Découvrir nos solutions",
        contact: "Nous contacter",
    },
    testimonials: {
        eyebrowIndex: "07",
        eyebrow: "Témoignages",
        title: "Ce qu'ils disent de leur expérience avec WEYB.",
        note: "Témoignages recueillis dans le cadre de missions et collaborations réelles.",
    },
};
